import { map, set } from "lodash";
import { mergeLastPayment } from "src/utils/mesaLeaseCore";
import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";
import { updateMesaSession } from "./mesas";
import { getOrdersSuccess } from "./order";
import { clearLocalStoragePreservingQr } from "src/utils/tmoQrStorage";
import journal from "src/utils/journal/journal";
import {
  markCheckPrintedLocally,
  revertCheckPrintedLocally,
} from "src/utils/tpv/checkPrintedLocal";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isClosingSession: false,
  startedSuccess: false,
  closesSuccess: false,
  updatedSuccess: false,
  paymentSuccess: false,
  isSessionAuthenticated: false,
  imFirstOnSession: false,
  isRequestingAccess: false,
  comensalId: 0,
  lastRequestAccess: null,
  error: false,
  error_message: null,
  sessions: [],
  activeStep: 0,
  session: null,
  connectedHub: false,
  hub: null,
  cuentaSelected: false,

  currentHeight: null,
  currentFilterName: "",

  // Último cobro registrado — se muestra como banner en la vista de mesas
  lastPayment: null,
  // { mesaName, total, cash, card, cashGiven, change, tipsEfectivo, tipsTarjeta, paymentMethodId, isPartial, timestamp }
};

const slice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    startRequestLoading(state) {
      state.isRequestingAccess = true;
    },
    stopRequestLoading(state) {
      state.isRequestingAccess = false;
      state.isSessionAuthenticated = false;
    },
    getInitializeSession(state, action) {
      state.isSessionAuthenticated = action.payload.isAuthenticated;
      state.session = action.payload.session;
      state.isRequestingAccess = false;
      state.isLoading = false;
    },
    getInitializeSessionError(state, action) {
      state.isSessionAuthenticated = false;
      state.session = state.session;
      state.isLoading = false;
      state.comensalId = 0;
      state.lastRequestAccess = null;
      state.isRequestingAccess = false;
    },
    onBackStep(state) {
      state.activeStep -= 1;
    },

    onNextStep(state) {
      state.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.activeStep = goToStep;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = true;
      state.error_message = action.payload;
      state.startedSuccess = false;
    },

    // GET PRODUCTS
    getSessionsSuccess(state, action) {
      state.isLoading = false;
      state.sessions = action.payload;
      state.startedSuccess = false;
    },
    getSessionsSuccessFromHub(state, action) {
      state.sessions = action.payload;
      if (state.session != null) {
        state.session = state.sessions.find((s) => (s.id = state.session.id));
        state.closesSuccess = state.session.isClosed;
        state.startedSuccess = state.session.isStarted;
      }
    },

    // GET PRODUCT
    getSessionSuccess(state, action) {
      state.isLoading = false;
      state.session = action.payload;
      state.startedSuccess = false;
    },
    getSessionByIdSession(state, action) {
      state.isLoading = false;
      state.session = action.payload;
      state.closesSuccess = state.session.isClosed;
      state.startedSuccess = state.session.isStarted;
      state.isSessionAuthenticated = state.session.isStarted;
    },

    updateSessionSuccess(state, action) {
      state.isLoading = false;
      state.session = action.payload;
      state.updatedSuccess = true;
    },

    closeSessionSuccess(state, action) {
      var session = action.payload;

      state.isLoading = false;
      //state.session = null;
      state.session = null;
      state.sessions = state.sessions.map((s) => {
        if (s.id === session.id) {
          if (session) return session;
          else
            return {
              ...s,
              isClosed: true,
            };
        } else return s;
      });
      state.closesSuccess = true;
      state.paymentSuccess = false;
      state.isSessionAuthenticated = false;
      state.comensalId = 0;
    },
    requestPaymentSuccess(state, action) {
      state.isLoading = false;
      state.paymentSuccess = true;
      state.closesSuccess = true;
      state.session = action.payload;
      state.isRequestingAccess = false;
    },
    requestAccessSession(state, action) {
      state.isLoading = false;
      state.isSessionAuthenticated = false;
      state.isRequestingAccess = true;
      state.comensalId = action.payload;
      state.lastRequestAccess = Date.now;
    },
    imFirstOnRequestingSession(state, action) {
      state.imFirstOnSession = action.payload.imFirst;
      state.session = action.payload.session;
    },
    AcceptAccesssuccess(state, action) {
      var comensales = state.session.comensales;
      comensales.find((c) => c.id == action.payload).approved = true;
      comensales.find((c) => c.id == action.payload).pendingApprove = false;

      state.session = { ...state.session, comensales: comensales };
    },
    DeclineAccessSuccess(state, action) {
      var comensales = state.session.comensales;
      comensales.find((c) => c.id == action.payload).approved = false;
      comensales.find((c) => c.id == action.payload).pendingApprove = false;

      state.session = { ...state.session, comensales: comensales };
      state.comensalId = 0;
    },
    StillPendingAccept(state, action) {
      state.isSessionAuthenticated = false;
      state.isRequestingAccess = true;
    },
    cleanSessionSucccessById(state, action) {
      state.isLoading = false;
      state.session = null;
      state.sessions = state.sessions.filter((s) => s.id !== action.payload);
    },
    cleanSessionSuccess(state, action) {
      state.isLoading = false;
      state.isClosingSession = false;
      state.startedSuccess = false;
      state.closesSuccess = false;
      state.updatedSuccess = false;
      state.paymentSuccess = false;
      state.isSessionAuthenticated = false;
      state.imFirstOnSession = false;
      state.isRequestingAccess = false;
      state.comensalId = 0;
      state.lastRequestAccess = null;
      state.error = false;
      state.error_message = null;
      state.sessions = [];
      state.activeStep = 0;
      state.session = null;
      state.connectedHub = false;
      state.hub = null;
      state.cuentaSelected = false;

      state.currentHeight = null;
      state.currentFilterName = "";
    },
    callCamareroSuccess(state, action) {
      state.session = action.payload;
    },
    receiveDataSuccess(state, action) {
      state.session = action.payload;
    },
    receiveSessionSuccess(state, action) {
      var session = action.payload.session;
      var new_sessions = map(state.sessions, (s) => {
        if (s.id === session.id) {
          return session;
        } else {
          return s;
        }
      });

      var session_exist = new_sessions.find((s) => s.id === session.id);
      if (session_exist === null) {
        new_sessions = [...new_sessions, session];
      }

      state.sessions = new_sessions;
      if (state.session.id === session.id) {
        state.session = session;
      }
    },
    printCuentaSuccess(state, action) {
      state.session = { ...state.session, printCuenta: false };
    },
    /*setPaymentTarjetaSuccess(state, action) {},
    setPaymentMixtoSuccess(state, action) {},
    setPaymentCashSuccess(state, action) {},*/
    setPaymentSuccess(state, action) {},
    setLastPayment(state, action) {
      state.lastPayment = action.payload;
    },
    // Fase 1 TPV · cobro llegado por el hub `payment/{rid}` o por
    // GET pedidos/pagos/last. Dedupe por paymentHistoryId y "gana el más
    // reciente" (ver mergeLastPayment en utils/mesaLeaseCore).
    receiveLastPayment(state, action) {
      state.lastPayment = mergeLastPayment(state.lastPayment, action.payload);
    },
    clearLastPayment(state) {
      state.lastPayment = null;
    },
    setCuentaSelected(state, action) {
      state.cuentaSelected = true;
    },
    setCuenta(state, action) {
      state.cuentaSelected = !state.cuentaSelected;
    },
    setIsClosingSession(state, action) {
      state.isClosingSession = action.payload;
    },
    setCurrentHeight(state, action) {
      state.currentHeight = action.payload;
    },
    setCurrentFilterName(state, action) {
      state.currentFilterName = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  updateSessionSuccess,
  closeSessionSuccess,
  getSessionsSuccess,
  getSessionSuccess,
  onGotoStep,
  onBackStep,
  onNextStep,
  requestPaymentSuccess,
  AcceptAccesssuccess,
  DeclineAccessSuccess,
  isRequestingAccess,
  cleanSessionSuccess,
  getInitializeSessionError,
  StillPendingAccept,
  receiveDataSuccess,
  getSessionsSuccessFromHub,
  receiveSessionSuccess,
  printCuentaSuccess,
  setPaymentSuccess,
  cleanSessionSucccessById,
  setCuentaSelected,
  setCuenta,
  setIsClosingSession,
  setCurrentHeight,
  setCurrentFilterName,
  setLastPayment,
  receiveLastPayment,
  clearLastPayment,
} = slice.actions;

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------
const setSession = (token, sessionId) => {
  localStorage.setItem("sessionId", sessionId);
  localStorage.setItem("tokenSession", token);

  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

const closeDataSession = () => {
  localStorage.removeItem("sessionId");
  localStorage.removeItem("tokenSession");
  localStorage.removeItem("comensalId");

  var user = window.localStorage.getItem("userId");

  if (user === null || user === "undefined") {
    delete axios.defaults.headers.common.Authorization;
  }
};

export function receiveSessionFromHub(session) {
  return async (dispatch) => {
    dispatch(slice.actions.receiveSessionSuccess({ session }));
  };
}

export function getSessionPing(session) {
  return async (dispatch) => {
    try {
      await axios.get(`data/hub/session/${session}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
        },
      });
      dispatch(slice.actions.callHubSuccess());
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
    }
  };
}

export function getSessions() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const userId = window.localStorage.getItem("userId");
    const response = await axios.get(`data/active/${userId}`);
    dispatch(slice.actions.getSessionsSuccess(response.data.sessions));
    try {
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// `extraProducts` (opcional): items del carrito local que aún no se han
// comandado (cart Redux con `old=false`). Se mandan al backend para que el
// ticket de cuenta los incluya como un "pre-ticket" — el cliente puede
// pedir la cuenta antes de que el camarero formalice los pedidos. No se
// persiste nada: solo entran en la generación del PDF.
export function printCuenta(id, idEmployee, idDiscount, extraProducts = null) {
  return async (dispatch) => {
    // Badge «cuenta impresa» al instante en este dispositivo (el servidor
    // marca la mesa en segundo plano tras generar el ticket).
    const mark = dispatch(markCheckPrintedLocally(id));
    try {
      dispatch(slice.actions.printCuentaSuccess());
      // Actividad del TPV: el pre-ticket (print.queued / print.skipped) cuelga de este click.
      journal.track("print.click", { kind: "precuenta" }, { sessionId: id });
      await axios.post(`data/print/${id}`, {
        idEmployee: idEmployee,
        idDiscount: idDiscount,
        extraProducts:
          Array.isArray(extraProducts) && extraProducts.length > 0
            ? extraProducts
            : null,
      });
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      // No se imprimió (ni se marcó en el servidor): fuera el badge optimista.
      dispatch(revertCheckPrintedLocally(mark));
      dispatch(slice.actions.hasError(error));
    }
  };
}

/*export function setPaymentCash(id) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setPaymentCashSuccess());
      await axios.get(`data/payment/cash/${id}`);
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') console.error(err);
      dispatch(slice.actions.hasError(err));
    }
  };
}

export function setPaymentTarjeta(id) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setPaymentTarjetaSuccess());
      await axios.get(`data/payment/card/${id}`);
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') console.error(err);
      dispatch(slice.actions.hasError(err));
    }
  };
}

export function setPaymentMixto(payment) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setPaymentMixtoSuccess());
      await axios.post(
        `data/payment/mixto`,
        JSON.stringify({
          idSession: payment.idSession,
          isFraccionado: payment.isFraccionado,
          cuentaEfectivo: payment.cuentaEfectivo,
          cuentaTarjeta: payment.cuentaTarjeta
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
          }
        }
      );
    } catch (err) {
      if (process.env.NODE_ENV !== 'production') console.error(err);
      dispatch(slice.actions.hasError(err));
    }
  };
}*/

export function setPayment(
  id,
  pagoTarjeta,
  pagoEfectivo,
  selectedFacturaCustomer,
) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.setPaymentSuccess());
      await axios.post(
        `data/payment`,
        JSON.stringify({
          idSession: id,
          cuentaTarjeta: pagoTarjeta,
          cuentaEfectivo: pagoEfectivo,
          idCustomer: selectedFacturaCustomer,
        }),
        {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
          },
        },
      );
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.error(err);
      dispatch(slice.actions.hasError(err));
    }
  };
}

export function getSession() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const sessionId = window.localStorage.getItem("sessionId");
      if (sessionId === null || sessionId === "undefined") {
        dispatch(
          slice.actions.hasError(new Error("Undefined session on cookies")),
        );
      } else {
        const response = await axios.get(`data/session/${sessionId}`);
        dispatch(slice.actions.getSessionSuccess(response.data.session));
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSessionWithIp() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      //const ip = await getIp();
      const sessionId = window.localStorage.getItem("sessionId");
      if (sessionId) {
        const getActual = await axios.get(`data/actual/session/${sessionId}`);
        dispatch(slice.actions.getSessionSuccess(getActual.data.session));
      } else {
        dispatch(slice.actions.getInitializeSessionError());
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSessionById(idMesa) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(
        "data/actual/session",
        JSON.stringify({
          idMesa: idMesa,
          date: new Date(),
        }),
        {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
          },
        },
      );
      dispatch(slice.actions.getSessionSuccess(response.data.session));
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSessionByIdSession(idSession) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.get(`data/actual/session/${idSession}`);
      dispatch(slice.actions.getSessionByIdSession(res.data.session));
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

const isActualSession = async (idMesa) => {
  try {
    const response = await axios.post(
      "data/actual/session",
      JSON.stringify({
        idMesa: idMesa,
        date: new Date(),
      }),
      {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
    if (response.data.session != null) {
      return [response.data.session.id, true];
    } else {
      return [-1, false];
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.error(error);
    return [-1, false];
  }
};

export function GiveAccess(id) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.AcceptAccesssuccess(id));
      await axios.post(`data/addComensal/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Access-Control-Allow-Origin": "*",
        },
      });
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function DeclineAccess(id) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.DeclineAccessSuccess(id));
      const response = await axios.post(`data/declineComensal/${id}`);
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function requestAccess(session, name) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `data/addComensal/requestIn`,
        JSON.stringify({
          //ip: ip,
          idSession: session.id,
          Name: name,
        }),
        {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
          },
        },
      );
      window.localStorage.setItem("comensalId", response.data.comensal);
      dispatch(slice.actions.requestAccessSession(response.data.comensal));
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// export function startSession(session, name) {
//   return async (dispatch) => {
//     try {
//       const res = await axios.get(`data/imFirst/${session.mesa}`);

//       if (!res.data.imFirst) {
//         const response = await axios.post(
//           `data/addComensal/requestIn`,
//           JSON.stringify({
//             //ip: ip,
//             idSession: res.data.sessionId,
//             Name: name
//           }),
//           {
//             headers: {
//               'Content-Type': 'application/json',
//               'X-Requested-With': 'XMLHttpRequest',
//               'Access-Control-Allow-Origin': '*'
//             }
//           }
//         );
//         window.localStorage.setItem('comensalId', response.data.comensal);
//         dispatch(slice.actions.requestAccessSession(response.data.comensal));
//       } else {
//       }
//     } catch (error) {
//       if (process.env.NODE_ENV !== 'production') console.error(error);
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }

export function closeSession(id, reason) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`data/closesession/${id}`, {
        reason: reason,
      });
      dispatch(slice.actions.closeSessionSuccess(response.data.session));
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function requestPaymentSession(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`data/payment/${id}`);
      dispatch(slice.actions.requestPaymentSuccess(response.data.session));
      // closeDataSession();
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function imFirstOnSessionRequest(idMesa) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`data/imFirst/${idMesa}`);

      if (response.data.imFirst === true) {
        dispatch(
          slice.actions.imFirstOnRequestingSession({
            imFirst: true,
            session: response.data?.session,
          }),
        );
      } else {
        dispatch(
          slice.actions.imFirstOnRequestingSession({
            imFirst: false,
            session: response.data?.session,
          }),
        );
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      //dispatch(slice.actions.imFirstOnRequestingSession(true));
    }
  };
}

export function getInitializeComensal() {
  return async (dispatch) => {
    try {
      const comensal = window.localStorage.getItem("comensalId");
      const getActual = await axios.get(`data/actual/comensal/${comensal}`);
      if (getActual.data.session != null) {
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: true,
            session: getActual.data.session,
          }),
        );

        setSession(getActual.data.session.token, getActual.data.session.id);
      } else {
        dispatch(slice.actions.StillPendingAccept());
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);

      if (error.status === 401) {
        closeDataSession();
        if (!window.localStorage.getItem("userId")) clearLocalStoragePreservingQr();

        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      } else {
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      }
    }
  };
}

export function getInitializeComensalSession() {
  return async (dispatch) => {
    try {
      const sessionId = window.localStorage.getItem("sessionId");
      const token = window.localStorage.getItem("tokenSession");
      const comensal = window.localStorage.getItem("comensalId");
      if (token && isValidToken(token)) {
        var getActual;
        if (sessionId) {
          getActual = await axios.get(`data/actual/session/${sessionId}`);
        } else if (comensal) {
          getActual = await axios.get(`data/actual/comensal/${comensal}`);
        }
        if (getActual.data.session === null) {
          dispatch(
            slice.actions.getInitializeSession({
              isAuthenticated: false,
              session: null,
            }),
          );
        } else {
          dispatch(
            slice.actions.getInitializeSession({
              isAuthenticated: true,
              session: getActual.data.session,
            }),
          );
          setSession(token, getActual.data.session.id);
        }
      } else {
        closeDataSession();
        if (!window.localStorage.getItem("userId")) clearLocalStoragePreservingQr();
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);

      if (error.status === 401) {
        closeDataSession();
        if (!window.localStorage.getItem("userId")) clearLocalStoragePreservingQr();
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      } else {
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      }
    }
  };
}

export function accessSessionAdmin(idMesa, restaurante) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios
        .get(`data/session/${idMesa}/${restaurante}`)
        .then((response) => {
          if (response.data.session != null) {
            journal.track("session.open", { pedidos: response.data.session.pedidos?.length ?? 0 }, { mesaId: response.data.session.idMesa, sessionId: response.data.session.id });
            dispatch(slice.actions.getSessionSuccess(response.data.session));
            // 2026-09-08 · Hidratar state.order.orders al mismo tick.
            if (Array.isArray(response.data.session.pedidos)) {
              dispatch(getOrdersSuccess(response.data.session.pedidos));
            }
            dispatch(
              updateMesaSession({
                mesa: response.data.session.idMesa,
                session: response.data.session.id,
              }),
            );
          }
        });
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
    }
  };
}

export function callCamarero(sessionId) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      if (sessionId) {
        const response = await axios.post(`data/camarero/${sessionId}`, {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
          },
        });

        dispatch(slice.actions.callCamareroSuccess(response.data.session));
      } else {
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      throw error;
    }
  };
}

export function sendCamarero(sessionId) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      if (sessionId) {
        const response = await axios.post(`data/sendCamarero/${sessionId}`, {
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
          },
        });
      } else {
        dispatch(
          slice.actions.getInitializeSession({
            isAuthenticated: false,
            session: null,
          }),
        );
      }
    } catch (error) {
      if (process.env.NODE_ENV !== "production") console.error(error);
      throw error;
    }
  };
}
